module.exports = __webpack_public_path__ + "static/media/engineering-works.37cd9441.png";